import moment from 'moment'

const GRAPH_VALUES = {
    FREQ: 'freq',
    TIME: 'time',
    BOTH: 'both',
}

const STATS_VALUES = {
    MEDIAN: 'median',
    AVERAGES: 'averages',
    VARIANCES: 'variances',
    MAX: 'max',
    MIN: 'min',
}

const sharedLocaleConfig = {
    s: '1s',
    ss: '%ds',
    m: '1m',
    mm: '%dm',
    h: '1h',
    hh: '%dh',
    d: '1d',
    dd: '%dd',
    M: '1M',
    MM: '%dM',
}

const durationLocaleConfig = {
    en: {
        ...sharedLocaleConfig,
        y: '1y',
        yy: '%dy',
    },
    es: {
        ...sharedLocaleConfig,
        y: '1a',
        yy: '%da',
    },
    pt: {
        ...sharedLocaleConfig,
        y: '1a',
        yy: '%da',
    },
}

/**
 * Normalize date
 * @param {Number|String} ms
 */
const normalizeDuration = (seconds) => {
    const userLocale = getCookie('inverbis%3Alang')
    const config = durationLocaleConfig[userLocale] || {}

    if (Object.keys(config).length > 0) {
        moment.updateLocale(userLocale, { relativeTime: config })
    }
    if (seconds === undefined || seconds === '') return ''
    if (seconds === 0) return 0

    return `${seconds < 0 ? '-' : ''}${moment.duration(seconds, 'seconds').locale(userLocale).humanize()}`
}

/**
 * Normalize kpi value
 * @param {Number} value
 */
const normalizeBothMetrics = (duration, frequency) => {
    if (!duration || !frequency) {
        return `${frequency}\n${normalizeDuration(duration)}`
    }
    return `${frequency}\n|\n${normalizeDuration(duration)}`
}

/**
 * Get stat value of model
 * @param {Object} data
 * @param {String} statsModel must be equal to one of STATS_VALUES
 */
const getStatValue = (data, statsModel) => {
    if (!data) return ''
    const options = {
        [STATS_VALUES.MEDIAN]: data.med,
        [STATS_VALUES.AVERAGES]: data.avg,
        [STATS_VALUES.VARIANCES]: data.sd,
        [STATS_VALUES.MAX]: data.max,
        [STATS_VALUES.MIN]: data.min,
    }
    return options[statsModel] || ''
}

/**
 * Get node value
 * @param {Number} statistics.frequency
 * @param {Number} statistics.duration
 * @param {Number} statistics.kpi
 * @param {Object} model
 */
const getInfoModel = ({
    frequency = '', duration,
} = {}, model = {}) => {
    const { values: target, statsValue: statsModel } = model
    const options = {
        [GRAPH_VALUES.TIME]: normalizeDuration(getStatValue(duration, statsModel)),
        [GRAPH_VALUES.BOTH]: normalizeBothMetrics(getStatValue(duration, statsModel), frequency),
        [GRAPH_VALUES.FREQ]: frequency,
    }

    return options[target] !== undefined ? options[target] : options[GRAPH_VALUES.FREQ]
}

function getCookie(name) {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`))
    return match ? decodeURIComponent(match[2]) : null
}
export default {
    getInfoModel,
    getStatValue,
    graphValues: GRAPH_VALUES,
    normalizeDuration,
}
